class WebSocketClass {
  /**
   *
   * @param {url,maxcount} opts
   */
  constructor(opts) {
    this.instance = null;
    this.isReconnect = true;
    this.url = opts.url;
    this.maxcount = opts.maxcount || 0;
    this.count = 0;
    this.fail = opts.fail;
    this.success = opts.success;
    this.connecting = opts.connecting;
    this.heartMsg=opts.heartMsg||'ping'
    this.durantion=opts.durantion||10000
    this.pingInterval = null
    this.token = opts.token
    this.connect();
  }
  static getInstance() {
    if (!this.instance) {
      this.instance = new WebSocketClass();
    }
    return this.instance;
  }

  connect() {
    this.ws = null;
    // this.ws = new WebSocket(this.url, [this.token]);
    this.ws = new WebSocket(this.url);
    this.count += 1;
    this.ws.onopen = () => {
      this.status = "open";
      this.success&&this.success();
      this.heartCheck();
      //   this.getMessage();
    };
    this.ws.onmessage = e => {
      this.connecting(e.data);
    };
    // this.ws.onerror = () => {
    //   this.closeHandle();
    // };
    this.ws.onclose = () => {
      setTimeout(()=>{
        this.closeHandle();
      },3000)
    };
  }

  heartCheck() {
    // 心跳机制的时间可以自己与后端约定
    this.pingPong = "ping"; // ws的心跳机制状态值
    clearTimeout(this.pingInterval)
    this.pingInterval = setTimeout(() => {
      if (this.ws.readyState === 1) {
        // 检查ws为链接状态 才可发送
        this.ws.send(this.heartMsg); // 客户端发送ping
      }
      this.heartCheck();
    }, this.durantion);
    // this.pongInterval = setTimeout(() => {
    //   if (this.pingPong === "ping") {
    //     this.closeHandle("pingPong没有改变为pong"); // 没有返回pong 重启webSocket
    //   }
    //   // 重置为ping 若下一次 ping 发送失败 或者pong返回失败(pingPong不会改成pong)，将重启
    //   console.log("返回pong");
    //   this.pingPong = "ping";
    // }, 2000);
  }
  setHeartMsg(msg){
    this.heartMsg=msg;
  }
  closeHandle(e = "err") {
    // 因为webSocket并不稳定，规定只能手动关闭(调closeMyself方法)，否则就重连
    if (this.status !== "close") {
      console.log(`断开，重连websocket`, e);
      if (this.pingInterval !== undefined) {
        // 清除定时器
        clearTimeout(this.pingInterval);
        // clearTimeout(this.pongInterval);
      }
      if (this.maxcount === this.count&&this.maxcount!==0) {
        this.fail();
      }
      this.connect(); // 重连
    } else {
      console.log(`websocket手动关闭,或者正在连接`);
    }
  }

  getMessage() {
    this.ws.onmessage = e => {
      this.pingPong = "pong";
      if (e.data === "pong") {
        // 服务器端返回pong,修改pingPong的状态
      }
      console.log(e.data);
      return e.data;
    };
  }

  close() {
    clearTimeout(this.pingInterval);
    // clearTimeout(this.pongInterval);
    this.status = "close";
    // this.ws.send("close");
    this.closeHandle();
    this.ws.close();
    this.ws = null;
    console.log("close");
  }
}
export default WebSocketClass;
